import { Icon } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateIconArgs,
    getDefaultIconCreateArgs,
    UpdateIconArgs,
} from "@nova/serializer/src/client/validators/cubes/icon"
import { getPackPrefix, getPackSize } from "@nova/component-map-icons"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { setIdRenaming } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectSingleLayer } from "panels/content/side-panel/slice.new"
import { maybeSetProjectLocation } from "../projectLocation"

const {
    create: createIcon,
    update: updateIcon,
    delete: deleteIcon,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    Icon, // entity type
    CreateIconArgs, // create args to send to server
    [
        "longitude",
        "latitude",
        "url",
        "color",
        "name",
        "parentId",
        "createdBy",
        "targetPayload",
        "outline",
        "width",
    ], // create args required by action
    UpdateIconArgs // update args
>("Icon")

export const addIconsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data } }, socket) => {
            const parts = data.url.split("/")
            const convertedUrl = parts.join(".")
            const pack = getPackPrefix(convertedUrl)
            const size = getPackSize(pack)
            const optimisticData = {
                id: randomUUID(),
                ...getDefaultIconCreateArgs(store.getState().project.data),
                ...data,
                size,
            }
            createIcon(socket, { ...data, id: optimisticData.id })
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["icons"],
                })
            )
            const project = store.getState().project.data
            maybeSetProjectLocation(store, project.orgId, project.id, {
                latitude: optimisticData.latitude,
                longitude: optimisticData.longitude,
            })

            store.dispatch(selectSingleLayer({ id: optimisticData.id }))
            // Enter layer renaming state in the Inspector Panel.
            store.dispatch(setIdRenaming(`inspector-layer-title-${optimisticData.id}`))
        })
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateIcon(socket, id, updates)
            store.dispatch(updateEntitySocket({ id, updates, path: ["icons", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteIcon(socket, id)
            store.dispatch(deleteEntitySocket({ path: ["icons", { id }] }))
        })

export { createAction as createIcon, updateAction as updateIcon, deleteAction as deleteIcon }
